import { render, staticRenderFns } from "./DataTypeQuestionWidget.vue?vue&type=template&id=0289a868&scoped=true"
import script from "./DataTypeQuestionWidget.vue?vue&type=script&lang=js"
export * from "./DataTypeQuestionWidget.vue?vue&type=script&lang=js"
import style0 from "./DataTypeQuestionWidget.vue?vue&type=style&index=0&id=0289a868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0289a868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSkeletonLoader,VTextField})
